
import React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import PhoneInput from 'react-phone-number-input';
import { isValidPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input';

const PhoneInputField = ({ input, label, meta: { touched, error, warning }, defaultCountry }) => {
    const [isValidPhone, setIsValidPhone] = useState(false);
    const [phoneExtention, setPhoneExtention] = useState('');
    const [isTouched, setIsTouched] = useState(false);

    const updatePhone = (value) => {
        let phone = '';
        if (value === undefined || value === null || value === '') {
            setPhoneExtention('');
            return;
        }

        for (let i = 0; i < Object.keys(value).length; i++) {
            phone += value[i] === undefined ? '' : value[i];
        }

        if (!value) {
            setPhoneExtention('');
            input.onChange('');
            return;
        }
        let num = value === undefined ? '' : value;

        setPhoneExtention(formatPhoneNumberIntl(phone).split(' ')[0]);
        setIsValidPhone(isValidPhoneNumber(num));
        input.onChange(num);
    };

    useEffect(() => {
        if (input.value) {
            updatePhone(input.value);
        }
    }, [input.value]);
    
    return (
        <div>
            
            <div className={`input_out ${touched && error ? 'input_out__invalid' : '' + 
                ( !isValidPhone  ? "input_out__invalid " : "")
                }`}>
                <div className={input.value ? "form-control__filled" : ""}>
                    <PhoneInput
                        placeholder=""
                        value={input.value}
                        defaultCountry={defaultCountry}
                        id="detail.phone"
                        onChange={updatePhone}
                        className={phoneExtention ? "showing_phoneExtention" : ""}
                        />
                    {label && (
                        <label className="form-label z-10 left-5 ml-n1" htmlFor="detail.phone">
                            {label}
                        </label>
                    )}
                    {phoneExtention && (
                        <label className="phone-prefix" htmlFor="detail.phone" style={{ top: '10px' }}>
                            {phoneExtention}
                        </label>
                    )}
                </div>
            </div>
            {touched && error && <span className="error-message">{error}</span>}
            {touched && warning && <span className="warning-message">{warning}</span>}
        </div>
    );
};

PhoneInputField.propTypes = {
    input: PropTypes.object.isRequired,
    label: PropTypes.string,
    defaultCountry: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
        warning: PropTypes.string,
    }).isRequired,
};

export default PhoneInputField;





// WEBPACK FOOTER //
// ./src/components/PhoneInputField.jsx